/* Wytamin Cart Fix
   Base: V125 stable cart behaviour.
   Patch: keep AJAX add-to-cart + drawer, and safely unlock page after drawer closes.
*/
(function(){
  if (window.WytaminCartFixV202DrawerUpsellFix) return;
  window.WytaminCartFixV202DrawerUpsellFix = true;

  function parseHTML(html){
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceCartSection(sectionId, html){
    if (!html) return;
    var doc = parseHTML(html);

    if (sectionId === 'cart-drawer') {
      var incomingDrawer = doc.querySelector('cart-drawer');
      var currentDrawer = document.querySelector('cart-drawer');
      if (incomingDrawer && currentDrawer) currentDrawer.outerHTML = incomingDrawer.outerHTML;
      return;
    }

    if (sectionId === 'cart-icon-bubble') {
      var currentBubble = document.querySelector('#cart-icon-bubble');
      if (!currentBubble) return;
      var incomingBubble = doc.querySelector('#cart-icon-bubble');
      if (incomingBubble) currentBubble.innerHTML = incomingBubble.innerHTML;
      else if (doc.body) currentBubble.innerHTML = doc.body.innerHTML;
    }
  }

  function unlockPageIfDrawerClosed(){
    var drawer = document.querySelector('cart-drawer');
    var isActive = drawer && drawer.classList.contains('active');
    if (!isActive) {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden-mobile');
      document.documentElement.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden-mobile');
    }
  }

  function forceCloseDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      unlockPageIfDrawerClosed();
      return;
    }

    try {
      if (typeof drawer.close === 'function') drawer.close();
    } catch(e) {}

    drawer.classList.remove('active');
    drawer.classList.remove('animate');
    drawer.removeAttribute('open');
    drawer.style.removeProperty('visibility');

    var inner = drawer.querySelector('#CartDrawer, .cart-drawer, .drawer__inner');
    if (inner) inner.classList.remove('active');

    setTimeout(unlockPageIfDrawerClosed, 30);
    setTimeout(unlockPageIfDrawerClosed, 250);
  }

  function openCartDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }
    try {
      if (typeof drawer.open === 'function') drawer.open();
    } catch(e) {}
    drawer.classList.add('active');
    drawer.classList.remove('is-empty');
    drawer.style.removeProperty('visibility');
    var inner = drawer.querySelector('#CartDrawer, .cart-drawer, .drawer__inner');
    if (inner) inner.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function refreshDrawer(sections){
    if (sections) {
      replaceCartSection('cart-drawer', sections['cart-drawer']);
      replaceCartSection('cart-icon-bubble', sections['cart-icon-bubble']);
      setTimeout(openCartDrawer, 60);
      return Promise.resolve();
    }

    return fetch('/?sections=cart-drawer,cart-icon-bubble', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(r){ return r.json(); })
      .then(function(data){
        replaceCartSection('cart-drawer', data['cart-drawer']);
        replaceCartSection('cart-icon-bubble', data['cart-icon-bubble']);
        setTimeout(openCartDrawer, 60);
      });
  }

  document.addEventListener('submit', function(event){
    var form = event.target && event.target.closest(
      'form[data-wytamin-ajax-cart], .wy-lux-form[action*="/cart/add"], cart-drawer form[action*="/cart/add"], .wyt-cart-upsell__form'
    );
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    var formPriceCents = parseInt(form.getAttribute('data-wyt-variant-price-cents') || '0', 10);
    if (form.getAttribute('data-wyt-variant-available') === 'false' || (form.hasAttribute('data-wyt-variant-price-cents') && formPriceCents <= 0)) {
      return;
    }

    var submitButton = form.querySelector('button[type="submit"], .wy-lux-add');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('is-loading');
      submitButton.setAttribute('aria-busy', 'true');
    }

    var card = form.closest('.wyt-cart-upsell__card');
    var chosenPlan = card && card.querySelector('.wyt-cart-upsell__select') ? card.querySelector('.wyt-cart-upsell__select').value : '';
    var hiddenPlan = form.querySelector('input[name="selling_plan"]');
    if (hiddenPlan) hiddenPlan.value = chosenPlan || '';

    var formData = new FormData(form);
    formData.set('sections', 'cart-drawer,cart-icon-bubble');
    formData.set('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function(response){
        if (!response.ok) return response.json().then(function(err){ throw err; });
        return response.json();
      })
      .then(function(cartResponse){
        return refreshDrawer(cartResponse.sections);
      })
      .catch(function(error){
        console.error('Wytamin AJAX cart add failed:', error);
        var message = (error && (error.description || error.message)) || 'This product could not be added to cart.';
        alert(message);
      })
      .finally(function(){
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
          submitButton.removeAttribute('aria-busy');
        }
      });
  }, true);

  /* Safety cleanup: after closing cart drawer, never leave the page locked. */
  document.addEventListener('click', function(event){
    var closeTarget = event.target && event.target.closest(
      'cart-drawer .drawer__close, cart-drawer #CartDrawer-Overlay, cart-drawer .cart-drawer__overlay, cart-drawer a[href]:not([href*="checkout"]):not([href*="/checkout"])'
    );
    if (!closeTarget) return;

    if (
      closeTarget.matches('cart-drawer .drawer__close, cart-drawer #CartDrawer-Overlay, cart-drawer .cart-drawer__overlay')
    ) {
      setTimeout(forceCloseDrawer, 0);
      return;
    }

    /* For Continue shopping / View cart links: unlock immediately before navigation. */
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-mobile');
    document.documentElement.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden-mobile');
  }, true);

  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape') setTimeout(forceCloseDrawer, 0);
  });
})();
